/**
 * AKU search/filter row (search box + status + normative_status selectors).
 */
import React from 'react';
import { Input } from '../../ui/input';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue
} from '../../ui/select';
import { Search } from 'lucide-react';

const AkuFilterBar = ({
  searchTerm, onSearchChange,
  filterStatus, onFilterStatusChange,
  filterNormative, onFilterNormativeChange,
}) => (
  <div className="flex gap-4 flex-wrap">
    <div className="flex-1 min-w-[200px]">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
        <Input
          placeholder="Claim suchen..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-9"
          data-testid="search-akus"
        />
      </div>
    </div>
    <Select
      value={filterStatus || 'ALL'}
      onValueChange={(v) => onFilterStatusChange(v === 'ALL' ? '' : v)}
    >
      <SelectTrigger className="w-[150px]" data-testid="filter-status">
        <SelectValue placeholder="Status" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="ALL">Alle Status</SelectItem>
        <SelectItem value="DRAFT">Entwurf</SelectItem>
        <SelectItem value="READY">Bereit</SelectItem>
        <SelectItem value="REJECTED">Abgelehnt</SelectItem>
        <SelectItem value="DEPRECATED">Veraltet</SelectItem>
      </SelectContent>
    </Select>
    <Select
      value={filterNormative || 'ALL'}
      onValueChange={(v) => onFilterNormativeChange(v === 'ALL' ? '' : v)}
    >
      <SelectTrigger className="w-[180px]" data-testid="filter-normative">
        <SelectValue placeholder="Normativ-Status" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="ALL">Alle</SelectItem>
        <SelectItem value="SUPPORTED_PRIMARY">PRIMARY</SelectItem>
        <SelectItem value="SUPPORTED_SECONDARY">SECONDARY</SelectItem>
        <SelectItem value="TRAINING_ONLY">TRAINING</SelectItem>
        <SelectItem value="CONFLICTING">KONFLIKT</SelectItem>
        <SelectItem value="AMBIGUOUS">MEHRDEUTIG</SelectItem>
      </SelectContent>
    </Select>
  </div>
);

export default AkuFilterBar;
